module.exports = __webpack_public_path__ + "media/images/topo-cc518239ba58d856a4a3091875586a57.png";